import { render, staticRenderFns } from "./ItemsAge.vue?vue&type=template&id=194a8bc6&scoped=true"
import script from "./ItemsAge.vue?vue&type=script&lang=js"
export * from "./ItemsAge.vue?vue&type=script&lang=js"
import style0 from "./ItemsAge.vue?vue&type=style&index=0&id=194a8bc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a8bc6",
  null
  
)

export default component.exports